// ThemeLoader owns the values, including its blue/green variants.
export const portalColors = {
  ink: 'var(--mexx-gray-900, #212121)',
  muted: 'var(--mexx-gray-700, #616161)',
  line: 'var(--mexx-gray-200, #eeeeee)',
  surface: 'var(--mexx-bg-secondary, #fafafa)',
  paper: 'var(--mexx-bg-primary, #ffffff)',
  accent: 'var(--mexx-green-primary, #8bc34a)',
  light: 'var(--mexx-green-light, #c8e6c9)',
  soft: 'var(--mexx-green-subtle, #f1f8e9)',
  // Preserve the configured hue with enough contrast for small white labels.
  action: 'color-mix(in srgb, var(--mexx-green-dark, #689f38) 72%, #000)',
};

export const portalFocus = {
  '&.Mui-focusVisible, &:focus-visible': {
    outline: `2px solid ${portalColors.action}`, outlineOffset: 3,
  },
};

export const portalLogo = {
  display: 'block', width: 'auto', height: '100%',
  maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
};

export const portalInput = {
  '& .MuiOutlinedInput-root': {
    minHeight: 48, borderRadius: '14px', backgroundColor: portalColors.paper,
    '& fieldset': { borderColor: portalColors.line },
    '&:hover fieldset, &.Mui-focused fieldset': { borderColor: `${portalColors.action} !important` },
  },
  '& input': { fontSize: 16, color: portalColors.ink, caretColor: portalColors.action },
  '& input::placeholder': { fontStyle: 'normal', color: `${portalColors.muted} !important`, opacity: '1 !important' },
  '& .MuiInputAdornment-root svg': { color: `${portalColors.muted} !important`, fill: 'none !important' },
};

export const portalMotion = {
  '@media (prefers-reduced-motion: reduce)': { transition: 'none', '& *': { transition: 'none !important' } },
};
